;(function () {
  'use strict'

  angular
    .module('contrast.users')
    .factory('bulkUploadService', bulkUploadService)

  function bulkUploadService(
    Blob,
    FileSaver,
    UserService,
    userBulkCreateErrors,
    AUTH_MODE,
    $translate
  ) {
    'ngInject'

    var docsUserAddMultipleLink = $translate.instant('link_addMultipleUsers')

    var headerUsername = 'Username,First Name,Last Name,Organization Role'
    var headerEmail = 'Email,First Name,Last Name,Organization Role'
    var superAdminHeaderUsername = 'Organization UUID,' + headerUsername
    var superAdminHeaderEmail = 'Organization UUID,' + headerEmail
    var headerProtect = ',Protect'

    var service = {
      buildBulkErrorMessage: buildBulkErrorMessage,
      downloadExample: downloadExample,
      useUsernameTemplate: useUsernameTemplate
    }

    return service

    function buildBulkErrorMessage(errors, _auth, _isSuperAdmin) {
      var out = []
      // Map all returned errors
      _.forEach(userBulkCreateErrors, function (bulkCreateError) {
        bulkCreateError.errors = _.filter(errors, function (err) {
          return err.errorType === bulkCreateError.errorType
        })
        bulkCreateError.errors.sort(function (x, y) {
          return x.line - y.line
        })

        // Format errors
        var msg = ''
        if (bulkCreateError.errors.length > 0) {
          var i
          if (bulkCreateError.errors.length > 5) {
            msg += bulkCreateError.displayName + ' on lines '
            for (i = 0; i < 5; i++) {
              msg += bulkCreateError.errors[i].line
              if (i < 4) {
                msg += ', '
              } else {
                msg += ', and ' + (bulkCreateError.errors.length - 5) + ' more.'
              }
            }
          } else if (bulkCreateError.errors.length > 2) {
            msg += bulkCreateError.displayName + ' on lines '
            for (i = 0; i < bulkCreateError.errors.length; i++) {
              if (i == 0) {
                msg += bulkCreateError.errors[i].line
              } else if (bulkCreateError.errors.length == i + 1) {
                msg += ', and ' + bulkCreateError.errors[i].line + '.'
              } else {
                msg += ', ' + bulkCreateError.errors[i].line
              }
            }
          } else if (bulkCreateError.errors.length == 2) {
            msg +=
              bulkCreateError.displayName +
              ' on lines ' +
              bulkCreateError.errors[0].line +
              ' and ' +
              bulkCreateError.errors[1].line +
              '.'
          } else {
            //(bulkCreateError.errors.length == 1)
            if (bulkCreateError.errorType == 'INVALID_HEADER') {
              msg +=
                'The file header is missing a required column. Try reviewing our <span class="user-bulk-error-link"><a href="' +
                docsUserAddMultipleLink +
                '" target="_blank" rel="noopener noreferrer">documentation</a></span>.'
            } else if (
              bulkCreateError.errorType == 'UNSUPPORTED_FILE_EXTENSION'
            ) {
              msg +=
                'This file type is not supported. Please upload a CSV file.'
            } else if (
              bulkCreateError.errorType == 'UNSUPPORTED_AUTHENTICATION_SETTINGS'
            ) {
              msg +=
                'This organization has authentication settings that do not allow user creation.'
            } else {
              msg +=
                bulkCreateError.displayName +
                ' on line ' +
                bulkCreateError.errors[0].line +
                '.'
            }
          }
          out.push(msg)
        }
      })
      return out
    }

    function downloadExample(auth, isSuperAdmin) {
      var header = ''
      var usernameTemplate = useUsernameTemplate(auth)
      var isProtectionEnabled =
        !isSuperAdmin && UserService.isOrganizationProtectionEnabled()

      if (usernameTemplate && isSuperAdmin) {
        header = superAdminHeaderUsername
      } else if (usernameTemplate && !isSuperAdmin) {
        //append protect field only if organization has protection enabled
        header = headerUsername + (isProtectionEnabled ? headerProtect : '')
      } else if (!usernameTemplate && isSuperAdmin) {
        header = superAdminHeaderEmail
      } else {
        //(!usernameTemplate && !isSuperAdmin)
        //append protect field only if organization has protection enabled
        header = headerEmail + (isProtectionEnabled ? headerProtect : '')
      }

      var blob = new Blob([header], { type: 'text/plain;charset=utf-8' })
      var file = 'contrast_user_creation_template.csv'
      FileSaver.saveAs(blob, file, true)
    }

    function useUsernameTemplate(auth) {
      return (
        auth.auth_mode === AUTH_MODE.mode.HTTP_HEADER ||
        auth.auth_mode === AUTH_MODE.mode.AD ||
        auth.auth_mode === AUTH_MODE.mode.LDAP
      )
    }
  }
})()
